import React from 'react';

import Loader from 'relements/build/esm/ui/loader';

// Error boundary
import ErrorBoundary from '@src/components/ErrorBoundary';
import { retryLazyLoad } from '@src/components/ErrorBoundary/utils';

import styles from './SubStories.scss';

// Removing lazy loading for now
const SubStories = React.lazy(() =>
  retryLazyLoad(() => import('./SubStories'))
);

export default function SubStoriesLazy(props) {
  return (
    <ErrorBoundary>
      <React.Suspense
        fallback={
          <div className={styles.substoriesLoader}>
            <Loader />
          </div>
        }
      >
        <SubStories {...props} />
      </React.Suspense>
    </ErrorBoundary>
  );
}
